export default "__VITE_ASSET__BHNRQoU9__"